// extracted by mini-css-extract-plugin
module.exports = {"FullWidth":"Deposit_FullWidth__p34Kx","TextAlert":"Deposit_TextAlert__2Akms","PaymentImage":"Deposit_PaymentImage__1C-Rn"};